module.exports = __webpack_public_path__ + "static/img/CStu6 拷贝@2x.b5b7c724.png";